import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { useI18N, useTheme } from "@sundae/react-hooks";
import { QuestionMarkCircledIcon, Header as SundaeHeader, Tooltip, } from "@sundae/ui-toolkit";
import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useIsWalletConnected } from "../../hooks/useIsWalletConnected.js";
import { defaultRoutes } from "../../routes/routes.js";
import { useAppContext } from "../../stores/index.js";
import QuickMenuPopover from "../QuickMenuPopover/index.js";
import WalletButton from "../WalletButton/index.js";
const Header = () => {
    const { t, currentLocale } = useI18N("header");
    const { state: { clientSettings: { brand, routes, externalRoutes, clientTranslations, enableLightTheme, }, }, } = useAppContext();
    const isWalletConnected = useIsWalletConnected();
    const { theme, toggleTheme } = useTheme();
    const navigate = useNavigate();
    const clientRoutes = useMemo(() => {
        return Object.values(routes).reduce((acc, curr) => {
            const renderedTitle = defaultRoutes.find(({ path }) => path === curr.path)
                ? t(`paths.${curr.i18nKey}`)
                : clientTranslations[currentLocale].navigation[curr.i18nKey];
            const isExternal = curr.path.includes("http");
            acc.push({
                title: renderedTitle,
                external: isExternal,
                href: isExternal ? curr.path : undefined,
                onClick: () => {
                    if (isExternal) {
                        return;
                    }
                    navigate(curr.path);
                },
            });
            return acc;
        }, []);
    }, [routes]);
    useEffect(() => {
        if (!enableLightTheme && theme !== "dark") {
            toggleTheme();
        }
    }, []);
    return (_jsx(SundaeHeader, { homepageLinkTitle: clientTranslations[currentLocale].title, isConnected: isWalletConnected, openOffCanvasLabel: t("header.menu.openOffCanvasLabel"), closeOffCanvasLabel: t("header.menu.closeOffCanvasLabel"), navigationItems: clientRoutes, renderTertiaryNav: ({ HeaderButton }) => (_jsxs(_Fragment, { children: [_jsx(Tooltip, { trigger: _jsx(HeaderButton, { onClick: () => window.open(externalRoutes.faq, "_blank"), children: _jsx(QuestionMarkCircledIcon, {}) }), tooltipLabel: "Visit our FAQ" }), _jsx(QuickMenuPopover, { openFrom: "top" })] })), renderLogo: ({ Link }) => {
            return (_jsx(Link, { variant: "primary", onClick: () => navigate("/"), title: clientTranslations[currentLocale].title, className: "flex items-center", children: brand.logos.header }));
        }, renderWalletButton: () => _jsx(WalletButton, {}), showThemeToggle: enableLightTheme, theme: theme, toggleTheme: toggleTheme }));
};
export default Header;
//# sourceMappingURL=Header.js.map